
import api from './api';

class Nps {

	constructor (Api) {
		this.Api = Api;
	}

	getStats (query) {
		return this.Api.get({
			url:  'v1.1/m/nps/stats/',
			query
		}).then(response => response.stats);
	}

}

Nps.$inject = ['Api'];

export default angular.module('service.nps', [api])
	.service('Nps', Nps)
	.name;


// WEBPACK FOOTER //
// ./src/service/nps.js